module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notification-a"
  }, [_c('div', [_c('div', [_c('h1', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("Purchase Successful!")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "button-type-e",
    staticStyle: {
      "font-size": "1.17em",
      "width": "100%"
    },
    on: {
      "click": _vm.endtransaction
    }
  }, [_vm._v("Done!")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("You may check your receipts "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Here")]), _c('br'), _vm._v("Thank you for choosing Apollo!")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06e06bce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderNotification.vue
// module id = 138
// module chunks = 0